import React from 'react';
import { ExpressionScope } from './ExpressionScope';
export var RecordsScope = function (props) {
    return (React.createElement(ExpressionScope, { value: {
            get $records() {
                var _a, _b;
                return (_b = (_a = props.getRecords) === null || _a === void 0 ? void 0 : _a.call(props)) !== null && _b !== void 0 ? _b : [];
            },
        } }, props.children));
};
//# sourceMappingURL=RecordsScope.js.map